/**
 * A value that repaints when it changes. Replaces the proxy-based property assignment of the
 * old framework: the reactive step is visible at the call site as `.value = x`.
 */
export class Property<TValue> {
    #value: TValue;
    readonly #paint: (value: TValue, previous: TValue) => void;

    constructor(initialValue: TValue, paint: (value: TValue, previous: TValue) => void, paintNow = true) {
        this.#value = initialValue;
        this.#paint = paint;
        if (paintNow) {
            paint(initialValue, initialValue);
        }
    }

    get value(): TValue {
        return this.#value;
    }

    set value(value: TValue) {
        const previous = this.#value;
        if (Object.is(previous, value)) {
            return;
        }
        this.#value = value;
        this.#paint(value, previous);
    }

    /** Repaints with the current value, for example after the node is re-attached. */
    repaint(): void {
        this.#paint(this.#value, this.#value);
    }
}
